const ROOTS = {
  auth: `/login`,
  user: '/user',
  location: '/location',
  packing_material: '/packing_material',
  common: '/common_code',
  role: '/role',
  mapping: '/mapping',
  purchase_order: '/purchase_order',
  client: '/client',
  courier: '/courier',
  product: '/product',
  stock_management: '/stock/management',
  stock: '/stock',
  inbound: '/inbound',
  order: '/order',
  bulk_order: '/bulk-order',
  return_order: '/return',
  outbound: '/outbound',
  outbound_packing: '/outbound-packing',
  outbound_picking: '/outbound-picking',
  bulk_outbound: '/bulk-outbound',
  advance_tracking_number: '/outbound-advance-tracking-number',
  bulk_picking: '/bulk-picking',
  bulk_packing: '/bulk-packing',
  menu: '/menu',
  machine: '/machine',
  excel: '/excel',
  dashboard: '/dashboard',
  qz: '/cert',
  print: '/print',
  return_inbound: '/return/inbound',
  webhook: '/webhook',
  sorting: '/sorting',
  adjustment_tasks: '/stock-adjustment-work',
  adjustment_management: '/stock-adjustment',
  carton: '/carton',
  label: '/label',
  reference: '/reference',
  feature_setting: '/feature-setting',
  location_mapping: '/location-mapping',
  shipper_setting: '/shipper/setting',
  app_release: '/app-release',
  location_manifest_lane: '/location-manifest-lane',
  manifest: '/manifest',
  mail: '/mail',
};

export const ENDPOINTS = {
  auth: {
    login: `${ROOTS.auth}/login`,
    logout: `${ROOTS.auth}/logout`,
    password_otp: `${ROOTS.auth}/password/reset`,
    password_reset: `${ROOTS.auth}/password`,
    refresh: `${ROOTS.auth}/refresh`,
  },
  user: {
    get_me: `${ROOTS.user}/info`,
    get_main: `${ROOTS.user}/setting/main`,
    get_location: (locationId) => `${ROOTS.user}/setting/location/${locationId}`,
    get_customer: (customerId) => `${ROOTS.user}/setting/customer/${customerId}`,
    get_list: `${ROOTS.user}/list`,
    post: `${ROOTS.user}`,
    put: (id) => `${ROOTS.user}/${id}`,
    get_user: (id) => `${ROOTS.user}/${id}`,
  },
  dashboard: {
    get: `${ROOTS.dashboard}`,
  },
  common: {
    get: `${ROOTS.common}/filter`,
  },
  role: {
    get: `${ROOTS.role}`,
  },
  menu: {
    get_role_menu: `${ROOTS.menu}/role`,
    get_setting_menu: `${ROOTS.menu}/setting`,
  },
  mapping: {
    get_location_courier: (locationId) => `${ROOTS.mapping}/location_courier/${locationId}`,
    delete_location_courier: (locationId, courierId) =>
      `${ROOTS.mapping}/location_courier/${locationId}/${courierId}`,
    post_location_courier: `${ROOTS.mapping}/location_courier`,
    put_location_courier: (locationId, courierId) =>
      `${ROOTS.mapping}/location_courier/${locationId}/${courierId}`,
    get_all: `${ROOTS.mapping}/code/all`,
  },
  location: {
    get: (id) => `${ROOTS.location}/${id}`,
    get_list: `${ROOTS.location}/list`,
    get_management_list: (type) => `${ROOTS.location}/management/list/${type}`,
    get_racks: (id) => `${ROOTS.location}/rack/${id}`,
    get_rack_info: (locationId, rackNumber) =>
      `${ROOTS.location}/rack/slot/${locationId}/${rackNumber}`,
    put_rack_info: (locationId, rackNumber) => `${ROOTS.location}/rack/${locationId}/${rackNumber}`,
    get_rack_barcode: (locationId, rackBarcode) =>
      `${ROOTS.location}/rack/slot/barcode/${locationId}/${rackBarcode}`,
    add_rack_slot: `${ROOTS.location}/rack/slot`,
    post: `${ROOTS.location}`,
    put: (id) => `${ROOTS.location}/${id}`,
    post_rack_or_tote: (type) => `${ROOTS.location}/${type}`,
    delete_rack_or_tote: (id, locationId, type) => `${ROOTS.location}/${type}/${locationId}/${id}`,
    update_tote: (id, locationId) => `${ROOTS.location}/tote/${locationId}/${id}`,
    tote_item: (locationId, toteNumber) =>
      `${ROOTS.location}/tote/item/${locationId}/${toteNumber}`,
    add_tote_item: `${ROOTS.location}/tote/item`,
    put_tote_item_bulk: (locationId, toteNumber) =>
      `${ROOTS.location}/tote/item/${locationId}/${toteNumber}/bulk`,
    post_cart: `${ROOTS.location}/cart`,
    put_cart_item_bulk: (locationId, cartNumber) =>
      `${ROOTS.location}/cart/item/${locationId}/${cartNumber}/bulk`,
    get_cart: (locationId, cartNumber) => `${ROOTS.location}/cart/item/${locationId}/${cartNumber}`,
    add_cart: `${ROOTS.location}/cart/item`,
    put_cart: (locationId, cartNumber) => `${ROOTS.location}/cart/${locationId}/${cartNumber}`,
    post_tote_excel_import: `${ROOTS.location}/tote/excel/import`,
    post_cart_excel_import: `${ROOTS.location}/cart/excel/import`,
  },
  packing_material: {
    get_list: `${ROOTS.packing_material}/list`,
    get: (id) => `${ROOTS.packing_material}/${id}`,
    get_history: (id) => `${ROOTS.packing_material}/${id}/history`,
    post: `${ROOTS.packing_material}`,
    put: (id) => `${ROOTS.packing_material}/${id}`,
    delete: (id) => `${ROOTS.packing_material}/${id}`,
  },
  order: {
    get_list: `${ROOTS.order}/list`,
    get_excel_list: `${ROOTS.order}/excel/list`,
    sort_list: `${ROOTS.order}/sort/list`,
    get: (id) => `${ROOTS.order}/${id}`,
    post: `${ROOTS.order}`,
    delete: (id) => `${ROOTS.order}/${id}`,
    mark_shipment: `${ROOTS.order}/shipment`,
    upsert: (id) => `${ROOTS.order}/upsert/${id}`,
    update: (id) => `${ROOTS.order}/update/${id}`,
    delete_item: (id, itemIndex) => `${ROOTS.order}/item/${id}/${itemIndex}`,
    post_import: `${ROOTS.order}/excel/import`,
    verify_address: `${ROOTS.order}/shipping-address/verify`,
    modify_address: (id) => `${ROOTS.order}/shipping-address/${id}`,
    oms_address_fail: `${ROOTS.order}/oms/fail-reason/async`,
    cancel_order: `${ROOTS.order}/admin/cancel`,
  },
  bulk_order: {
    get_list: `${ROOTS.bulk_order}/list`,
    get_excel_list: `${ROOTS.bulk_order}/excel/list`,
    sort_list: `${ROOTS.bulk_order}/sort/list`,
    stock_list: `${ROOTS.bulk_order}/stock/available`,
    post: `${ROOTS.bulk_order}`,
    get: (bulkOrderId) => `${ROOTS.bulk_order}/detail/${bulkOrderId}`,
    delete: (bulkOrderId) => `${ROOTS.bulk_order}/${bulkOrderId}`,
    mark_shipment: `${ROOTS.bulk_order}/shipment`,
    cancel_order: (bulkOrderId) => `${ROOTS.bulk_order}/cancel/${bulkOrderId}`,
    upsert: (bulkOrderId) => `${ROOTS.bulk_order}/upsert/${bulkOrderId}`,
    delete_item: (bulkOrderId, itemSequence) =>
      `${ROOTS.bulk_order}/item/${bulkOrderId}/${itemSequence}`,
    update: (bulkOrderId) => `${ROOTS.bulk_order}/update/${bulkOrderId}`,
    update_consignee: (bulkOrderId) => `${ROOTS.bulk_order}/consignee/${bulkOrderId}`,
    cancel: `${ROOTS.bulk_order}/admin/cancel`,
    delete_order: `${ROOTS.bulk_order}/delete`,
    post_import: `${ROOTS.bulk_order}/excel/import`,
  },
  return_order: {
    get_list: `${ROOTS.return_order}/list`,
    sort_list: `${ROOTS.return_order}/sort/list`,
    get: (id) => `${ROOTS.return_order}/${id}`,
    upsert: (id) => `${ROOTS.return_order}/upsert/${id}`,
    post: `${ROOTS.return_order}`,
    delete: (id) => `${ROOTS.return_order}/${id}`,
    delete_item: (returnId) => `${ROOTS.return_order}/item/${returnId}`,
    request: `${ROOTS.return_order}/request`,
    cancel: `${ROOTS.return_order}/cancel`,
    shipped_for_return: `${ROOTS.return_order}/shipped-for-return`,
    post_import: `${ROOTS.return_order}/excel/import`,
    pickup_request: (returnId) => `${ROOTS.return_order}/${returnId}/pickup-request`,
  },
  purchase_order: {
    get_list: `${ROOTS.purchase_order}/list`,
    get_excel_list: `${ROOTS.purchase_order}/excel/list`,
    get: (id) => `${ROOTS.purchase_order}/${id}`,
    post: `${ROOTS.purchase_order}`,
    mark_ordered: (id) => `${ROOTS.purchase_order}/ordered/${id}`,
    mark_closed: (id) => `${ROOTS.purchase_order}/closed/${id}`,
    sort_list: `${ROOTS.purchase_order}/sort/list`,
    delete: (id) => `${ROOTS.purchase_order}/${id}`,
    delete_item: (purchaseOrderId, purchaseOrderLine) =>
      `${ROOTS.purchase_order}/item/${purchaseOrderId}/${purchaseOrderLine}`,
    upsert: (id) => `${ROOTS.purchase_order}/upsert/${id}`,
    shipment: (id) => `${ROOTS.purchase_order}/shipment/${id}`,
    post_import: `${ROOTS.purchase_order}/excel/import`,
  },
  product: {
    get_list: `${ROOTS.product}/list`,
    post_import: `${ROOTS.product}/excel/import`,
    post: `${ROOTS.product}/image_file`,
    get_by_user: (userId, sku) => `${ROOTS.product}/${userId}/${sku}`,
    delete_by_user: (userId, sku) => `${ROOTS.product}/${userId}/${sku}`,
    put_by_user: (userId, sku) => `${ROOTS.product}/${userId}/${sku}`,
    put_image_by_user: (userId, sku) => `${ROOTS.product}/image/${userId}/${sku}`,
    delete_image_by_user: (userId, sku) => `${ROOTS.product}/image/${userId}/${sku}`,
    outerbox_sort_list: `${ROOTS.product}/outer-box/sort/list`,
    outerbox_list: `${ROOTS.product}/outer-box/list`,
    outerbox_get: (id) => `${ROOTS.product}/outer-box/${id}`,
    post_outerbox: `${ROOTS.product}/outer-box/`,
    edit_outerbox: (id) => `${ROOTS.product}/outer-box/${id}`,
    generate_outerbox: `${ROOTS.product}/outer-box/barcode/generate`,
    delete_outerbox: (id) => `${ROOTS.product}/outer-box/${id}`,
    delete_bulk_outerbox: `${ROOTS.product}/outer-box/bulk`,
    restore_outerbox: (id) => `${ROOTS.product}/outer-box/restore/${id}`,
    restore_bulk_outerbox: `${ROOTS.product}/outer-box/restore/bulk`,
  },
  stock: {
    get_list: `${ROOTS.stock_management}/list`,
    get_excel_list: `${ROOTS.stock_management}/excel/list`,
    sort_list: `${ROOTS.stock_management}/sort/list`,
    location_list: (locationId) => `${ROOTS.stock_management}/list/${locationId}`,
    bulk_lot_expiration: `${ROOTS.stock}/lot-expiration/bulk`,
    put_away: {
      purchase_order_list: `${ROOTS.stock}/put-away/purchase-order/list`,
      pending: `${ROOTS.stock}/put-away/pending`,
      scan: `${ROOTS.stock}/put-away/scan`,
      placement: `${ROOTS.stock}/put-away/placement`,
      bulk: `${ROOTS.stock}/put-away/bulk`,
    },
    transfer: {
      purchase_order_list: `${ROOTS.stock}/transfer/purchase-order/list`,
      pending: `${ROOTS.stock}/transfer/pending`,
      scan: `${ROOTS.stock}/transfer/scan`,
      placement: `${ROOTS.stock}/put-away/placement`,
      bulk: `${ROOTS.stock}/transfer/bulk`,
      excel_sample: `${ROOTS.stock}/transfer/excel/sample`,
      excel_import: `${ROOTS.stock}/transfer/excel/import`,
    },
  },
  client: {
    get_list: `${ROOTS.client}/list`,
    sort_list: `${ROOTS.client}/sort/list`,
    delete: (id) => `${ROOTS.client}/${id}`,
    post: `${ROOTS.client}`,
    get: (id) => `${ROOTS.client}/${id}`,
    put: (id) => `${ROOTS.client}/${id}`,
    post_channel_add_image: `${ROOTS.client}/image`,
    put_image: (clientId) => `${ROOTS.client}/image/${clientId}`,
    delete_image: (clientId) => `${ROOTS.client}/image/${clientId}`,
  },
  courier: {
    get: (locationId) => `${ROOTS.courier}/${locationId}`,
    get_couriers: (locationId) => `${ROOTS.courier}/service/${locationId}`,
    create_tracking_number: `${ROOTS.courier}/tracking-number/range`,
    import_tracking_number: `${ROOTS.courier}/tracking-number/range/excel/import`,
    delete_tracking_number: (locationId, courierId) =>
      `${ROOTS.courier}/tracking-number/range/${locationId}/${courierId}`,
    get_couriers_export: (locationId, courierId) =>
      `${ROOTS.courier}/tracking-number/range/${locationId}/${courierId}`,
    get_courier_setting: (userId) =>
      `${ROOTS.courier}/user/shipping/product-name/setting/${userId}`,
    post_courier_setting: `${ROOTS.courier}/user/shipping/product-name/setting`,
  },
  inbound: {
    get_list: `${ROOTS.inbound}/list`,
    get: (poId) => `${ROOTS.inbound}/${poId}`,
    get_item_history: (poId, purchaseOrderLine) => `${ROOTS.inbound}/${poId}/${purchaseOrderLine}`,
    sort_list: `${ROOTS.inbound}/sort/list`,
    post: `${ROOTS.inbound}/receiving`,
    delete_received: (receivingId, cancelReasonCode) =>
      `${ROOTS.inbound}/received/cancel/${receivingId}/${cancelReasonCode}`,
    putaway: {
      get: `${ROOTS.inbound}/put_away`,
      post: `${ROOTS.inbound}/put_away`,
    },
    get_excel_list: `${ROOTS.inbound}/excel/list`,
    get_excel_sample: `${ROOTS.inbound}/receiving/excel/sample`,
    post_excel_import: `${ROOTS.inbound}/receiving/excel/import`,
    get_excel_sample_without_po: `${ROOTS.inbound}/receiving/excel/import/auto-po/sample`,
    post_excel_import_without_po: `${ROOTS.inbound}/receiving/excel/import/auto-po`,
  },
  outbound: {
    get_list: `${ROOTS.outbound}/list`,
    get_excel_list: `${ROOTS.outbound}/excel/list`,
    sort_list: `${ROOTS.outbound}/sort/list`,
    get: (id) => `${ROOTS.outbound}/${id}`,
    picking: {
      get: (locationId) => `${ROOTS.outbound_picking}/${locationId}`,
      get_detail: (shipmentPickingId) => `${ROOTS.outbound_picking}/detail/${shipmentPickingId}`,
      get_sort: (shipmentPickingId) => `${ROOTS.outbound}/sorting/${shipmentPickingId}`,
      post: `${ROOTS.outbound_picking}`,
      delete: (shipmentPickingId) => `${ROOTS.outbound_picking}/${shipmentPickingId}`,
      print_status: (shipmentPickingId) =>
        `${ROOTS.outbound_picking}/print/status/${shipmentPickingId}`,
      post_complete: `${ROOTS.outbound_picking}/complete`,
      post_picking_tote_mapping: `${ROOTS.outbound_picking}/shipment/tote/mapping`,
      post_sorting_tote_mapping: `${ROOTS.outbound}/sorting/shipment/tote/mapping`,
      delete_sorting_tote_mapping: (locationId, toteNumber, toteItemNumber) =>
        `${ROOTS.outbound}/sorting/shipment/tote/unmapping/${locationId}/${toteNumber}/${toteItemNumber}`,
      get_sorting_list: `${ROOTS.outbound}/sorting/list`,
      post_cart_mapping: `${ROOTS.outbound_picking}/cart/mapping`,
      get_tote: (locationId, toteBarcode) =>
        `${ROOTS.outbound}/sorting/tote/${locationId}/${toteBarcode}`,
      get_sorting_scan: (locationId, scanType, scanNumber) =>
        `${ROOTS.outbound}/sorting/${locationId}/${scanType}/${scanNumber}`,
      picking_total_print_list: `${ROOTS.outbound_picking}/total/print/list`,
      get_available_count: (locationId) =>
        `${ROOTS.outbound_picking}/${locationId}/available-count`,
    },
    packing: {
      get_single: (locationId, packingScanType, scanNumber) =>
        `${ROOTS.outbound}/packing/single/${locationId}/${packingScanType}/${scanNumber}`,
      get_multi: (locationId, packingScanType, scanNumber) =>
        `${ROOTS.outbound}/packing/multi/${locationId}/${packingScanType}/${scanNumber}`,
      get_all_single: (locationId, packingScanType) =>
        `${ROOTS.outbound}/packing/single/list/${locationId}/${packingScanType}`,
      post: `${ROOTS.outbound}/packing`,
    },
    issue: {
      put: (orderShipmentId) => `${ROOTS.outbound}/issue/${orderShipmentId}`,
    },
    shipping: {
      post: `${ROOTS.outbound}/shipped`,
    },
    put_requested_shipping_date: (orderShipmentId) =>
      `${ROOTS.outbound}/${orderShipmentId}/requested-shipping-date`,
  },
  outbound_packing: {
    get_multi: (locationId, scanType, scanNumber) =>
      `${ROOTS.outbound_packing}/multi/${locationId}/${scanType}/${scanNumber}`,
    get_single_picking: (locationId, pickingNumber) =>
      `${ROOTS.outbound_packing}/single/${locationId}/picking?pickingNumber=${pickingNumber}`,
    get_single_scan: (locationId, pickingNumber, orderShipmentId) =>
      `${ROOTS.outbound_packing}/single/${locationId}/scan?pickingNumber=${pickingNumber}&orderShipmentId=${orderShipmentId}`,
    get_single_scan_value: (locationId, pickingNumber, value) =>
      `${ROOTS.outbound_packing}/single/${locationId}/scan?pickingNumber=${pickingNumber}&value=${value}`,
    post_single_pack: (locationId) => `${ROOTS.outbound_packing}/single/${locationId}/pack`,
    get_general_scan: (locationId, value) =>
      `${ROOTS.outbound_packing}/general/${locationId}/scan?value=${value}`,
    get_single: (locationId, scanType, scanNumber) =>
      `${ROOTS.outbound_packing}/single/${locationId}/${scanType}/${scanNumber}`,
    get_all_single: (locationId, scanType) =>
      `${ROOTS.outbound_packing}/single/list/${locationId}/${scanType}`,
    put_box: (orderShipmentId, boxSequence) =>
      `${ROOTS.outbound_packing}/${orderShipmentId}/boxes/${boxSequence}`,
    post_packing: `${ROOTS.outbound_packing}`,
    post_packing_shipped: `${ROOTS.outbound_packing}/shipped`,
    post_close_box: (orderShipmentId, boxSequence) =>
      `${ROOTS.outbound_packing}/${orderShipmentId}/boxes/${boxSequence}/close`,
    post_reopen_box: (orderShipmentId, boxSequence) =>
      `${ROOTS.outbound_packing}/${orderShipmentId}/boxes/${boxSequence}/reopen`,
    post_revert: (orderShipmentId) => `${ROOTS.outbound_packing}/${orderShipmentId}/revert`,
    delete_box: (orderShipmentId, boxSequence) =>
      `${ROOTS.outbound_packing}/${orderShipmentId}/boxes/${boxSequence}`,
    get_single_scan_selection: (locationId, pickingNumber, orderShipmentId, value) =>
      `${ROOTS.outbound_packing}/single/${locationId}/scan?pickingNumber=${pickingNumber}&orderShipmentId=${orderShipmentId}&value=${value}`,
    delete_claims: (locationId) => `${ROOTS.outbound_packing}/claims/${locationId}`,
  },
  bulk_outbound: {
    sort_list: `${ROOTS.bulk_outbound}/sort/list`,
    get_list: `${ROOTS.bulk_outbound}/list`,
    get_excel_list: `${ROOTS.bulk_outbound}/excel/list`,
    put_requested_shipping_date: (bulkShipmentId) =>
      `${ROOTS.bulk_outbound}/${bulkShipmentId}/requested-shipping-date`,
    get: (id) => `${ROOTS.bulk_outbound}/${id}`,
    put: (id) => `${ROOTS.bulk_outbound}/${id}`,
    upload_image: (id) => `${ROOTS.bulk_outbound}/${id}/photos`,
    delete_image: (id) => `${ROOTS.bulk_outbound}/${id}/photos`,
    print_tracking_label: (bulkShipmentId) =>
      `${ROOTS.bulk_outbound}/${bulkShipmentId}/tracking-label`,
    print_packing_list: (bulkShipmentId) => `${ROOTS.bulk_outbound}/${bulkShipmentId}/packing-list`,
    print_packing_list_status: (bulkShipmentId) =>
      `${ROOTS.bulk_outbound}/${bulkShipmentId}/packing-list/status`,
    mark_shipped: (bulkShipmentId) => `${ROOTS.bulk_outbound}/${bulkShipmentId}/shipped`,
    mark_shipped_by_trackingNumber: (trackingNumber) =>
      `${ROOTS.bulk_outbound}/shipped-by-tracking/${trackingNumber}`,
  },
  advance_tracking_number: {
    get_couriers: `${ROOTS.advance_tracking_number}/couriers`,
    post_search: `${ROOTS.advance_tracking_number}/search`,
    post_issue: `${ROOTS.advance_tracking_number}/issue`,
    get_jobs: `${ROOTS.advance_tracking_number}/jobs`,
    get_job: (jobId) => `${ROOTS.advance_tracking_number}/jobs/${jobId}`,
    post_retry: `${ROOTS.advance_tracking_number}/retry`,
    post_void: `${ROOTS.advance_tracking_number}/void`,
    post_resend: `${ROOTS.advance_tracking_number}/notifications/resend`,
    get_history: (orderShipmentId) => `${ROOTS.advance_tracking_number}/${orderShipmentId}/history`,
  },
  bulk_packing: {
    get: (locationId, scanType, scanValue) =>
      `${ROOTS.bulk_packing}/${locationId}/${scanType}/${scanValue}`,
    put_box: (bulkShipmentId, boxSequence) =>
      `${ROOTS.bulk_packing}/${bulkShipmentId}/boxes/${boxSequence}`,
    post_packing: `${ROOTS.bulk_packing}`,
    post_close_box: (bulkShipmentId, boxSequence) =>
      `${ROOTS.bulk_packing}/${bulkShipmentId}/boxes/${boxSequence}/close`,
    post_reopen_box: (bulkShipmentId, boxSequence) =>
      `${ROOTS.bulk_packing}/${bulkShipmentId}/boxes/${boxSequence}/reopen`,
    post_revert: (bulkShipmentId) => `${ROOTS.bulk_packing}/${bulkShipmentId}/revert`,
    delete_box: (bulkShipmentId, boxSequence) =>
      `${ROOTS.bulk_packing}/${bulkShipmentId}/boxes/${boxSequence}`,
  },
  bulk_picking: {
    post: `${ROOTS.bulk_picking}`,
    get_available_list: `${ROOTS.bulk_picking}/available-shipments`,
    get_available_count: (locationId) => `${ROOTS.bulk_picking}/${locationId}/available-count`,
    get_detail_list: (bulkPickingId) => `${ROOTS.bulk_picking}/detail/${bulkPickingId}`,
    post_complete: `${ROOTS.bulk_picking}/complete`,
    delete: (bulkPickingId) => `${ROOTS.bulk_picking}/${bulkPickingId}`,
    print_list: `${ROOTS.bulk_picking}/total/print/list`,
    print_status: (bulkPickingId) => `${ROOTS.bulk_picking}/total/print/status/${bulkPickingId}`,
    get_picking_list: (locationId) => `${ROOTS.bulk_picking}/${locationId}`,
    post_cart_mapping: `${ROOTS.bulk_picking}/cart/mapping`,
    delete_cart: (locationId, cartBarcode) =>
      `${ROOTS.bulk_picking}/cart/unmapping/${locationId}/${cartBarcode}`,
    delete_carts: (bulkPickingId) => `${ROOTS.bulk_picking}/cart/unmapping/${bulkPickingId}`,
  },
  machine: {
    get: (machineId) => `${ROOTS.machine}/${machineId}`,
    get_list: `${ROOTS.machine}/list`,
    post_machine: `${ROOTS.machine}`,
    put_machine: (machineId) => `${ROOTS.machine}/${machineId}`,
    delete_machine: (machineId) => `${ROOTS.machine}/${machineId}`,
    delete_machine_endpoint: (machineId, sequence) => `${ROOTS.machine}/${machineId}/${sequence}`,
    sorter: {
      get_list: `${ROOTS.machine}/sorter/list`,
      get: (locationId, doorId) => `${ROOTS.machine}/sorter/${locationId}/${doorId}`,
      post: `${ROOTS.machine}/sorter`,
      put: (locationId, doorId) => `${ROOTS.machine}/sorter/${locationId}/${doorId}`,
      delete: (locationId, doorId) => `${ROOTS.machine}/sorter/${locationId}/${doorId}`,
    },
  },
  excel: {
    get_template: (type) => `${ROOTS.excel}/sample/${type}`,
  },
  qz: {
    post_signature: `${ROOTS.qz}/qz-tray/sign-message`,
    get_certificate: `${ROOTS.qz}/qz-tray/digital-certificate`,
  },
  print: {
    post_document: `${ROOTS.print}/document`,
    get_document_status: (printHistoryId) => `${ROOTS.print}/document/status/${printHistoryId}`,
    get_catalog: `${ROOTS.print}/catalog`,
    get_target_search: `${ROOTS.print}/target/search`,
    get_target_box_list: `${ROOTS.print}/target/box-list`,
    get_sample: `${ROOTS.print}/sample`,
    get_history: `${ROOTS.print}/history`,
    post_reprint: (printHistoryId) => `${ROOTS.print}/reprint/${printHistoryId}`,
    print_picking: (shipmentPickingId) => `${ROOTS.print}/picking-list/${shipmentPickingId}`,
    re_print: (shipmentPickingId) => `${ROOTS.print}/packing-label/reprint/${shipmentPickingId}`,
  },
  return_inbound: {
    get_list: `${ROOTS.return_inbound}/list`,
    sort_list: `${ROOTS.return_inbound}/sort/list`,
    available_list: `${ROOTS.return_inbound}/available-list`,
    get_by_tracking_number: (locationId, trackingNumber) =>
      `${ROOTS.return_inbound}/by-tracking-number/${locationId}/${trackingNumber}`,
    get: (returnId) => `${ROOTS.return_inbound}/${returnId}`,
    post_received: (returnId) => `${ROOTS.return_inbound}/${returnId}/received`,
    upload_photos: (returnId) => `${ROOTS.return_inbound}/${returnId}/photos`,
    delete_photos: (returnId) => `${ROOTS.return_inbound}/${returnId}/photos`,
    upload_item_photos: (returnId, itemSequence) =>
      `${ROOTS.return_inbound}/${returnId}/items/${itemSequence}/photos`,
    delete_item_photos: (returnId, itemSequence) =>
      `${ROOTS.return_inbound}/${returnId}/items/${itemSequence}/photos`,
    excel_list: `${ROOTS.return_inbound}/excel/list`,
    put_fees: (returnId) => `${ROOTS.return_inbound}/${returnId}/fees`,
    put_receiving_fees: (returnId, receivingSequence) =>
      `${ROOTS.return_inbound}/${returnId}/receivings/${receivingSequence}/fees`,
  },
  webhook: {
    get_list: `${ROOTS.webhook}/user/list`,
    get_by_user: (userId) => `${ROOTS.webhook}/user/${userId}`,
    put_by_user: (userId) => `${ROOTS.webhook}/user/${userId}/webhook`,
  },
  sorting: {
    get_scan_sorting: (locationId, scanType, scanNumber) =>
      `${ROOTS.sorting}/${locationId}/${scanType}/${scanNumber}`,
    get_scan_tote_setup: (id) => `${ROOTS.sorting}/tote-setup/${id}`,
    get_varify_tote: (locationId, toteBarcode) =>
      `${ROOTS.sorting}/tote/validation/${locationId}/${toteBarcode}`,
    post_tote_mapping: `${ROOTS.sorting}/tote/auto-mapping`,
    delete_tote_mapping: (id, locationId, toteNumber, toteItemNumber) =>
      `${ROOTS.sorting}/tote/mapping/${id}/${locationId}/${toteNumber}/${toteItemNumber}`,
    post_start_sorting: `${ROOTS.sorting}/start`,
    get_sorting_process: (id) => `${ROOTS.sorting}/process/${id}`,
    post_scan_sorting_process: `${ROOTS.sorting}/process/scan`,
  },
  adjustment_tasks: {
    get_sort_list: `${ROOTS.adjustment_tasks}/sort/list`,
    get_adjustment_tasks_list: `${ROOTS.adjustment_tasks}/list`,
    get_adjustment_tasks_excel_list: `${ROOTS.adjustment_tasks}/excel/list`,
    get_adjustment_task: (id) => `${ROOTS.adjustment_tasks}/${id}`,
    post_apply_adjustment_task: (id) => `${ROOTS.adjustment_tasks}/${id}/apply`,
    post_cancel_adjustment_task: (id) => `${ROOTS.adjustment_tasks}/${id}/cancel`,
    put_adjustment_task_note: (id) => `${ROOTS.adjustment_tasks}/${id}/note-from-location`,
  },
  adjustment_management: {
    get_sort_list: `${ROOTS.adjustment_management}/sort/list`,
    get_adjustment_management_list: `${ROOTS.adjustment_management}/list`,
    get_adjustment_management_excel_list: `${ROOTS.adjustment_management}/excel/list`,
    get_adjustment_management: (id) => `${ROOTS.adjustment_management}/${id}`,
    put_adjustment_management: (id) => `${ROOTS.adjustment_management}/${id}`,
    delete_adjustment_management: (id) => `${ROOTS.adjustment_management}/${id}`,
    post_adjustment_management: `${ROOTS.adjustment_management}`,
    delete_adjustment_management_item: (id, stockAdjustmentItemId) =>
      `${ROOTS.adjustment_management}/${id}/item/${stockAdjustmentItemId}`,
    post_submit_adjustment: (id) => `${ROOTS.adjustment_management}/${id}/submit`,
    post_cancel_adjustment: (id) => `${ROOTS.adjustment_management}/${id}/cancel`,
    put_adjustment_management_note: (id) => `${ROOTS.adjustment_management}/${id}/note-to-location`,
    post_tags_adjustment_task: (id) => `${ROOTS.adjustment_tasks}/${id}/tags`,
    delete_tags_adjustment_management: (id) => `${ROOTS.adjustment_tasks}/${id}/tags`,
  },
  label: {
    barcode_product: `${ROOTS.label}/barcode/product`,
    barcode_product_simple: `${ROOTS.label}/barcode/product-simple`,
    barcode_outer_box: `${ROOTS.label}/barcode/outer-box`,
    barcode_tote: `${ROOTS.label}/barcode/tote`,
    barcode_cart: `${ROOTS.label}/barcode/cart`,
    barcode_rack: `${ROOTS.label}/barcode/rack`,
    barcode_carton: `${ROOTS.label}/barcode/carton`,
    post_print: `${ROOTS.label}/print`,
    post_print_excel: `${ROOTS.label}/print/excel`,
    get_template_list: `${ROOTS.label}/template/list`,
    get_template_element_list: `${ROOTS.label}/template/element/list`,
    get_template_excel_form: (id) => `${ROOTS.label}/template/${id}/excel-form`,
    get_print_excel_form: (printType) => `${ROOTS.label}/print/${printType}/excel-form`,
  },
  carton: {
    get_sort_list: `${ROOTS.carton}/sort/list`,
    get_carton_list: `${ROOTS.carton}/list`,
    get_carton: (id) => `${ROOTS.carton}/${id}`,
    put_carton: (id) => `${ROOTS.carton}/${id}`,
    delete_carton: (id) => `${ROOTS.carton}/${id}`,
    post_tags: (id) => `${ROOTS.carton}/${id}/tags`,
    delete_tags: (id) => `${ROOTS.carton}/${id}/tags`,
    get_carton_excel_list: `${ROOTS.carton}/excel/list`,
    get_packing_list: (id) => `${ROOTS.carton}/${id}/packing-list`,
    post_items: (id) => `${ROOTS.carton}/${id}/items`,
    delete_items: (id) => `${ROOTS.carton}/${id}/items`,
    delete_items_box: (id, cartonItemId) => `${ROOTS.carton}/${id}/items/${cartonItemId}`,
    post_carton: `${ROOTS.carton}`,
    post_carton_pack: (id) => `${ROOTS.carton}/${id}/pack`,
    post_carton_reopen: (id) => `${ROOTS.carton}/${id}/reopen`,
    post_carton_ship: (id) => `${ROOTS.carton}/${id}/ship`,
    post_carton_cancel: (id) => `${ROOTS.carton}/${id}/cancel`,
  },
  reference: {
    get_stock_list: `${ROOTS.reference}/stock`,
    get_stock_type: `${ROOTS.reference}/stock-type`,
    get_date_type: `${ROOTS.reference}/date-type`,
    get_product_code_type: `${ROOTS.reference}/product-code-type`,
    get_courier_list: (id) => `${ROOTS.reference}/courier-account/${id}`,
    get_bulk_courier_list: (id) => `${ROOTS.reference}/courier-account/bulk/${id}`,
    get_feature_setting: `${ROOTS.reference}/feature-setting`,
    get_cart_availability: (locationId, cartBarcode) =>
      `${ROOTS.reference}/cart/availability/${locationId}/${cartBarcode}`,
    get_shipper_courier: `${ROOTS.reference}/shipper-courier`,
    get_channel: `${ROOTS.reference}/channel`,
    get_customer: `${ROOTS.reference}/customer`,
  },
  app_release: {
    get_qr_link: `${ROOTS.app_release}/qr-link`,
    get_list: `${ROOTS.app_release}/list`,
    post: `${ROOTS.app_release}`,
    patch_active: (appReleaseId) => `${ROOTS.app_release}/${appReleaseId}/active`,
  },
  feature_setting: {
    get_feature_list: `${ROOTS.feature_setting}/list`,
    get_feature_key_list: `${ROOTS.feature_setting}/key/list`,
    get_feature: (id) => `${ROOTS.feature_setting}/${id}`,
    put_feature: (id) => `${ROOTS.feature_setting}/${id}`,
    delete_feature: (id) => `${ROOTS.feature_setting}/${id}`,
    post_feature: `${ROOTS.feature_setting}`,
  },
  location_mapping: {
    get_user_list: (locationId) => `${ROOTS.location_mapping}/user/${locationId}`,
    get_user_candidate_list: (locationId) =>
      `${ROOTS.location_mapping}/user/${locationId}/candidate`,
    get_courier_list: (locationId) => `${ROOTS.location_mapping}/courier/${locationId}`,
    post_user: `${ROOTS.location_mapping}/user`,
    delete_user: (locationId, userId) => `${ROOTS.location_mapping}/user/${locationId}/${userId}`,
  },
  shipper_setting: {
    post_shipper_setting: `${ROOTS.shipper_setting}`,
    get_shipper_setting_list: `${ROOTS.shipper_setting}/list`,
    get_shipper_setting_resolve: `${ROOTS.shipper_setting}/resolve`,
    get_shipper_setting_detail: (id) => `${ROOTS.shipper_setting}/${id}`,
    put_shipper_setting: (id) => `${ROOTS.shipper_setting}/${id}`,
    delete_shipper_setting: (id) => `${ROOTS.shipper_setting}/${id}`,
  },
  manifest_setting: {
    get_list: `${ROOTS.location_manifest_lane}/list`,
    get: (laneId) => `${ROOTS.location_manifest_lane}/${laneId}`,
    post: `${ROOTS.location_manifest_lane}`,
    put: (laneId) => `${ROOTS.location_manifest_lane}/${laneId}`,
    delete: (laneId) => `${ROOTS.location_manifest_lane}/${laneId}`,
    post_activate: (laneId) => `${ROOTS.location_manifest_lane}/${laneId}/activate`,
    post_deactivate: (laneId) => `${ROOTS.location_manifest_lane}/${laneId}/deactivate`,
    get_channel_list: `${ROOTS.manifest}/channel/list`,
  },
  manifest: {
    get_sort_list: `${ROOTS.manifest}/sort/list`,
    post: `${ROOTS.manifest}`,
    get_list: `${ROOTS.manifest}/list`,
    get_excel_list: `${ROOTS.manifest}/excel/list`,
    get: (id) => `${ROOTS.manifest}/${id}`,
    delete: (id) => `${ROOTS.manifest}/${id}`,
    get_lines: (id) => `${ROOTS.manifest}/${id}/lines`,
    post_lines: (id) => `${ROOTS.manifest}/${id}/lines`,
    post_resolve: `${ROOTS.manifest}/eligible/resolve`,
    get_eligible: `${ROOTS.manifest}/eligible`,
    get_status: (id) => `${ROOTS.manifest}/${id}/status`,
    get_document: (id, documentType) => `${ROOTS.manifest}/${id}/document/${documentType}`,
    get_file: (id, fileId) => `${ROOTS.manifest}/${id}/document/${fileId}/download`,
    put_info: (id) => `${ROOTS.manifest}/${id}/info`,
    delete_line: (id, lineId) => `${ROOTS.manifest}/${id}/lines/${lineId}`,
    post_transmit: (id, submissionId) =>
      `${ROOTS.manifest}/${id}/submissions/${submissionId}/transmit`,
    post_retry: (id, submissionId) => `${ROOTS.manifest}/${id}/submissions/${submissionId}/retry`,
    post_close: (id) => `${ROOTS.manifest}/${id}/close`,
    put_submissions: (id) => `${ROOTS.manifest}/${id}/submissions`,
    post_line_void: (id, lineId) => `${ROOTS.manifest}/${id}/lines/${lineId}/void`,
    put_line_boxes: (id, lineId) => `${ROOTS.manifest}/${id}/lines/${lineId}/boxes`,
    post_reply_preview: (id) => `${ROOTS.manifest}/${id}/broker-reply/preview`,
    post_reply_apply: (id) => `${ROOTS.manifest}/${id}/broker-reply/apply`,
    get_invoice_templates: `${ROOTS.manifest}/invoice-template/list`,
    post_reopen: (id) => `${ROOTS.manifest}/${id}/reopen`,
    post_cancel: (id) => `${ROOTS.manifest}/${id}/cancel`,
    post_void_all: (id) => `${ROOTS.manifest}/${id}/void-all`,
    post_submission_void: (id, submissionId) =>
      `${ROOTS.manifest}/${id}/submissions/${submissionId}/void`,
    post_release_failed: (id, submissionId) =>
      `${ROOTS.manifest}/${id}/submissions/${submissionId}/release-failed`,
  },
  mail: {
    get_list: `${ROOTS.mail}/list`,
    get_attachment: (mailId, attachmentId) => `${ROOTS.mail}/${mailId}/attachment/${attachmentId}`,
    get: (mailId) => `${ROOTS.mail}/${mailId}`,
    post_retry: (mailId) => `${ROOTS.mail}/${mailId}/retry`,
    get_draft: `${ROOTS.mail}/draft`,
    get_draft_attachment: `${ROOTS.mail}/draft/attachment`,
    post_draft_upload: `${ROOTS.mail}/draft/upload`,
    post_draft_preview: `${ROOTS.mail}/draft/preview`,
    post_send: `${ROOTS.mail}/send`,
  },
};
